import { Link, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useState } from "react";

const NAV = [
  { label: "Inicio", to: "/" },
  { label: "Colección", to: "/catalogo" },
  { label: "Sobre GALOLÀ", to: "/sobre" },
  { label: "Tips de Foto", to: "/tips-fotografia" },
];

const Header = () => {
  const { totalQty, setOpen } = useCart();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md bg-[#F9F6F0]/85 border-b border-[#E5E0D8]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-3 items-center h-20">
          {/* Left nav */}
          <nav className="hidden md:flex gap-8 items-center">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                data-testid={`nav-${n.to.replace("/", "") || "home"}`}
                className={`label-tracked transition-colors ${
                  location.pathname === n.to
                    ? "text-[#C27A62]"
                    : "text-[#1E1E1E] hover:text-[#C27A62]"
                }`}
              >
                {n.label}
              </Link>
            ))}
          </nav>

          <button
            className="md:hidden justify-self-start"
            onClick={() => setMobileOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>

          {/* Logo */}
          <Link
            to="/"
            className="text-center font-serif-editorial text-[1.7rem] tracking-[0.25em] text-[#1E1E1E]"
            data-testid="brand-logo"
          >
            GALOLÀ
          </Link>

          {/* Right - cart */}
          <div className="justify-self-end flex items-center">
            <button
              onClick={() => setOpen(true)}
              data-testid="open-cart-btn"
              className="relative inline-flex items-center gap-2 label-tracked text-[#1E1E1E] hover:text-[#C27A62] transition-colors"
            >
              <ShoppingBag size={18} strokeWidth={1.5} />
              <span className="hidden sm:inline">Cesta</span>
              {totalQty > 0 && (
                <span
                  data-testid="cart-count"
                  className="absolute -top-2 -right-3 bg-[#C27A62] text-white text-[10px] rounded-full w-5 h-5 flex items-center justify-center font-medium"
                >
                  {totalQty}
                </span>
              )}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-6 flex flex-col gap-4 border-t border-[#E5E0D8] pt-4">
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setMobileOpen(false)}
                className="label-tracked text-[#1E1E1E]"
                data-testid={`mobile-nav-${n.to.replace("/", "") || "home"}`}
              >
                {n.label}
              </Link>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
